import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    '& .Mui-focusVisible': {
      outline: '3px solid grey',
      outlineOffset: '-3px',
    },
  },
}));
